var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeRoutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.5,20.8L42.5,20.8c0-0.6-0.3-1.1-0.8-1.4c-0.5-0.3-1.1-0.4-1.6-0.2c-0.8,0.3-1.2,1-1.2,2c0,1.2,0,2.5,0,3.7 c0,2.6,0,5.3,0,7.9c0,1.5-0.8,3-2,4c-1.3,1.1-2.9,1.5-4.5,1.2c-2.8-0.5-4.7-2.8-4.7-5.6l0-7c0-2.5,0-5,0-7.5c0-0.5,0-1-0.1-1.5 c-0.3-2.5-1.6-4.8-3.8-6.4c-2.1-1.6-4.8-2.1-7.3-1.6C12,9.3,8.9,13,8.9,17.6c0,2.7,0,5.3,0,8l0,3.3c0,0.1,0,0.3,0,0.4 c0.1,0.9,0.8,1.5,1.7,1.6c0.9,0.1,1.7-0.5,1.9-1.3c0.1-0.3,0.1-0.6,0.1-0.9l0-4.1c0-2.3,0-4.5,0-6.8c0-0.6,0-1.1,0.1-1.5 c0.6-2.8,3.3-4.6,6.1-4.3c2.7,0.3,4.9,2.7,4.9,5.5c0,1.7,0,3.5,0,5.2l0,3.8c0,1,0,2,0,3c0,0.4,0,0.7,0,1.1c0,1,0,2.1,0.1,3.1 c0.3,2.5,1.6,4.8,3.7,6.3c1.6,1.2,3.6,1.8,5.5,1.8c0.6,0,1.2-0.1,1.8-0.2c4.5-0.9,7.5-4.6,7.5-9.2c0-2.4,0-4.9,0-7.3l0-3.2l0-0.3 C42.5,21.4,42.6,21.1,42.5,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.5,1.9c-3.9,0-7.8,0-11.7,0c-1.1,0-1.6,0.5-1.6,1.6c0,3.9,0,7.8,0,11.7c0,1.1,0.5,1.6,1.6,1.6 c1.9,0,3.9,0,5.8,0c2,0,3.9,0,5.9,0c1.1,0,1.6-0.5,1.6-1.6c0-3.9,0-7.8,0-11.7C48.2,2.4,47.7,1.9,46.5,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,34c-0.7-1.2-1.9-1.2-2.6,0C7.1,38,4.7,41.9,2.3,45.8c-0.3,0.5-0.5,1-0.2,1.6C2.4,48,3,48.1,3.6,48.1 c2.4,0,4.8,0,7.2,0c2.4,0,4.8,0,7.2,0c0.6,0,1.2-0.1,1.5-0.7c0.3-0.6,0.1-1.1-0.2-1.6C16.9,41.9,14.5,38,12.1,34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRoutes);
export default __webpack_public_path__ + "static/media/change-routes.035b1c3ce7c5987428215a2e1ee3d915.svg";
export { ForwardRef as ReactComponent };